import React from "react";
import { formatLastActivityDate } from "../../../helpers/utils";
import { HistoryOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";

function LastActivity({
  updatedAt,
  qnId,
  category,
  openAuditTrail,
  updateAuditData,
}) {
  const handleOpenAudit = () => {
    openAuditTrail(true);
    updateAuditData(qnId, category?.category_id);
  };

  return (
    <Tooltip
      placement="bottom"
      title="Show activity log"
      color={"#0F1117"}
      overlayInnerStyle={{ fontSize: "13px" }}
    >
      <div className="history-wrapper" onClick={handleOpenAudit}>
        <HistoryOutlined />
        <div
          className="last-updated"
          dangerouslySetInnerHTML={formatLastActivityDate(updatedAt)}
        ></div>
      </div>
    </Tooltip>
  );
}

export default LastActivity;
